import { Table } from "@mui/material";
// import { styled, width } from "@mui/system";
import { styled } from "@mui/material/styles";

const CustomTableSmall = styled(Table)(({ theme }) => ({
  border: "1px solid #d5d5d5",
  "& .MuiTableRow-head": {
    border: "1px solid #d5d5d5",
    backgroundColor: "#edf4fb",
    height: "55px",
    maxHeight: "55px",
  },
  "& .MuiTableCell-head": {
    // border: "1px solid #d5d5d5",
    backgroundColor: "#edf4fb",
    height: "55px",
    maxHeight: "55px",
  },
  "& .MuiTableCell-root": {
    // border: "1px solid #d5d5d5",
    wordBreak: "break-word",
    minWidth: "100px",
  },
  "& .width-text-column": {
    width: "200px",
    minWidth: "200px",
  },
  "& .dateText": {
    width: "110px",
    minWidth: "110px",
  },

  maxHeight: "calc(100vh - 250px)",
  overflowY: "auto",
}));

export default CustomTableSmall;
